export const chunck = (originalArr, chunckSize) => {
  const arr = [];
  for (let i = 0; i < originalArr.length; i += chunckSize) {
    arr.push(originalArr.slice(i, i + chunckSize));
  }
  return arr;
};
